// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"5f879db4","511":"c4ccab4a","673":"0f020c28","767":"b874936c"}[chunkId] + ".chunk.js";
};